import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const Icon = styled.img`
    width: 24px;
    height: 24px;
`;

export const Title = styled.h2`
    ${setFontVariant("subTitle3", colorsPalettes.carbon[500])};
`;

export const List = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    gap: 12px;
    margin: 0 0 0 4px;
`;

export const BulletItem = styled.li`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const BulletText = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;
